module.exports = __webpack_public_path__ + "img/crotch_height.9dd77e81.png";